module.exports = __webpack_public_path__ + "img/border.07e5a964.jpg";